import {React,useState} from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Typography, Button,Menu,MenuItem } from '@mui/material';
import MDButton from "components/MDButton";

import MDBox from "components/MDBox";
import Organization from '..';
import { red } from '@mui/material/colors';

const ProjkeyCard = ({keyData,editformData,deleteKey}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const scriptContent = `<script src="?apikey=${keyData.consumerprivate}&org_id=${keyData.organizationId}"></script>`;

  return (
    <Card sx={{  boxShadow: 3 }}>
       <MDBox sx={{ position: 'absolute', top: 8, right: 8 }}>
        <MDButton onClick={handleMenuOpen}>
              I
        </MDButton>
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {/* <MenuItem onClick={() => editformData(keyData)}>Edit</MenuItem> */}
          <MenuItem onClick={() => deleteKey(keyData)}>Delete</MenuItem>
        </Menu>
      </MDBox>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          {keyData.name}
        </Typography>
        <Typography variant="h6" component="div" gutterBottom>
          {keyData.consumerprivate}
        </Typography>
        <Typography variant="h6" component="div" gutterBottom>
            <pre  style={{
              background: "black",
              color:"red",
              padding: "10px",
              borderRadius: "5px",
              overflowX: "auto",
              whiteSpace: "pre-wrap", // Ensures content wraps properly
              wordBreak: "break-word", // Prevents breaking in the wrong places
            }}>
               {scriptContent}
             </pre>
        </Typography>
      </CardContent>
    </Card>
  );
};
ProjkeyCard.propTypes = {
  keyData:PropTypes.object.isRequired,
  editformData: PropTypes.func.isRequired,
  deleteKey: PropTypes.func.isRequired
};
export default ProjkeyCard;
